var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndianExpressLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.503906,
    width: 64,
    height: 64,
    rx: 8,
    fill: "#FFD3D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.728 29.3213L32.8489 19.5187C31.4224 18.2665 32.362 16.2017 32.362 16.2017L32.1383 16.0039L29.8628 18.8485C28.5847 20.421 28.8091 22.787 30.3352 24.1245L41.2152 33.9271C42.6409 35.1793 41.7021 37.2441 41.7021 37.2441L41.9257 37.4427L44.2012 34.5981C45.4793 33.0248 45.2549 30.6596 43.7288 29.3213H43.728Z",
    fill: "#FF1204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7139 35.6024L27.834 25.799C26.4083 24.5467 27.3471 22.482 27.3471 22.482L27.1227 22.2842L24.8472 25.1287C23.5691 26.702 23.7935 29.0673 25.3196 30.4047L36.1995 40.2074C37.6252 41.4596 36.6864 43.5251 36.6864 43.5251L36.9109 43.7229L39.1863 40.8784C40.4645 39.3051 40.24 36.9398 38.7139 35.6024Z",
    fill: "#FF1204"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6975 41.8825L22.8176 32.0799C21.3919 30.8276 22.3307 28.7629 22.3307 28.7629L22.107 28.5643L19.8316 31.4089C18.5534 32.9822 18.7779 35.3474 20.304 36.6856L31.1831 46.4883C32.6096 47.7405 31.67 49.8053 31.67 49.8053L31.8937 50.0038L34.1692 47.1593C35.4473 45.586 35.2229 43.2207 33.6968 41.8825H33.6975Z",
    fill: "#FF1204"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndianExpressLogo);
export default __webpack_public_path__ + "static/media/IndianExpressLogo.d62f5e3aaf4d1cbca5bf055190550f63.svg";
export { ForwardRef as ReactComponent };